<template>
    <div class="email__email-sidebar h-full">
        <VuePerfectScrollbar class="email-scroll-area" :settings="settings">
            <vs-collapse ref="queriesSidebar" accordion id="queriesSidebar" class="p-0 vs-con-loading__container">
                <vs-collapse-item v-for="(server, key) in databases" :key="key">
                    <div slot="header" class="flex justify-between items-center cursor-pointer mt-2 db-list" @click="changeServer(server.servidor)" >
                        <div class="flex items-center mb-2">
                            <feather-icon :icon="server.icon" :svgClasses="[{'text-primary stroke-current': selectedServer === server.servidor}, 'h-6 w-6']"></feather-icon>
                            <span class="text-lg ml-3">{{server.name}}</span>
                        </div>
                    </div>
                    <div v-for="(db, i) in server.dbs" :key="i">
                        <div class="db-title my-1" :class="{'text-primary': selectedDB === db.banco && selectedServer === server.servidor}" @click="selectDb(server.servidor, db.banco, db)">
                            <feather-icon icon="CircleIcon" :svgClasses="{'text-primary stroke-current': selectedDB === db.banco && selectedServer === server.servidor}"></feather-icon>
                            {{ db.title }}
                        </div>
                        <tree-item
                                v-show="selectedDB === db.banco"
                                v-for="(item, k) in db.children"
                                :key="k"
                                class="item"
                                :item="item"
                                @selected="itemSelected"
                                @toggle="updateHeight"
                        ></tree-item>
                    </div>
                </vs-collapse-item>

            </vs-collapse>
        </VuePerfectScrollbar>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    const _ = require("lodash");

    export default {
        name: "queriessidebar",
        props: {
            selected: {
                type: String,
                default: 'Prodbitis',
            }
        },
        components: {
            VuePerfectScrollbar: () => import('vue-perfect-scrollbar'),
            TreeItem: () => import('./TreeItem')
        },
        data() {
            return {
                databases: [
                    {
                        name: 'Prod',
                        icon: 'DatabaseIcon',
                        servidor: 'prodbitis',
                        dbs: [
                            {
                                title: 'Comercio',
                                banco: 'comercio',
                                children: []
                            },
                            {
                                title: 'Consulta',
                                banco: 'consulta',
                                children: []
                            },
                            {
                                title: 'Exclaim',
                                banco: 'exclaims',
                                children: []
                            },
                            {
                                title: 'Billing',
                                banco: 'billing',
                                children: []
                            },
                            {
                                title: 'Fiscal',
                                banco: 'fiscal',
                                children: []
                            },
                            {
                                title: 'Jurídico',
                                banco: 'juridico',
                                children: []
                            },
                            {
                                title: 'Interatividade',
                                banco: 'interatividade',
                                children: []
                            },
                            {
                                title: 'Charm9',
                                banco: 'charm9',
                                children: []
                            },
                            {
                                title: 'Clini9',
                                banco: 'clini9',
                                children: []
                            },
                            {
                                title: 'IntegraSMS',
                                banco: 'integrasms',
                                children: []
                            },
                            {
                                title: 'Reports',
                                banco: 'reports',
                                children: []
                            },
                            {
                                title: 'Comanda Premium',
                                banco: 'comanda_bd',
                                children: []
                            },
                        ]
                    },
                    {
                        name: 'Homolog',
                        icon: 'DatabaseIcon',
                        servidor: 'homologbitis',
                        dbs: [
                            {
                                title: 'Bitis',
                                banco: 'comercio',
                                children: []
                            },
                            {
                                title: 'Consulta',
                                banco: 'consulta',
                                children: []
                            },
                            {
                                title: 'Exclaim',
                                banco: 'exclaims',
                                children: []
                            },
                            {
                                title: 'Billing',
                                banco: 'billing',
                                children: []
                            },
                            {
                                title: 'Fiscal',
                                banco: 'fiscal',
                                children: []
                            },
                            {
                                title: 'Jurídico',
                                banco: 'juridico',
                                children: []
                            },
                            {
                                title: 'Interatividade',
                                banco: 'interatividade',
                                children: []
                            },
                            {
                                title: 'Charm9',
                                banco: 'charm9',
                                children: []
                            },
                            {
                                title: 'Clini9',
                                banco: 'clini9',
                                children: []
                            },
                            {
                                title: 'IntegraSMS',
                                banco: 'integrasms',
                                children: []
                            },
                            {
                                title: 'Reports',
                                banco: 'reports',
                                children: []
                            },
                            {
                                title: 'Comanda Premium',
                                banco: 'comanda_bd',
                                children: []
                            },
                        ],
                    },
                    {
                        name: 'Intranet',
                        icon: 'DatabaseIcon',
                        servidor: 'intranet',
                        dbs: [
                            {
                                title: 'Intranet',
                                banco: 'intranet',
                                children: []
                            },
                            {
                                title: 'Homologação',
                                banco: 'homolog_intranet',
                                children: []
                            },
                        ],
                    },
                ],
                query: {
                    schema: null,
                    table: null,
                    columns: [],
                },
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: 0.30,
                },
            }
        },
        computed: {
            ...mapGetters('queries', ['selectedServer', 'selectedDB']),
        },
        methods: {
            ...mapActions('queries', ['updateSelectedServer', 'updateSelectedDB', 'updateQuery']),
            changeServer(servidor) {
                this.updateSelectedServer(servidor);
                this.query = {
                    schema: null,
                    table: null,
                    columns: [],
                };
                this.updateQuery('');
            },
            updateHeight: _.debounce(function () {
                this.$refs.queriesSidebar.$children.forEach(item => item.$el.scrollHeight && item.changeHeight());
            }, 400),
            initLoading() {
                this.$vs.loading({
                    container: '#queriesSidebar',
                    scale: 0.6
                });
            },
            stopLoading() {
                this.$vs.loading.close('#queriesSidebar > .con-vs-loading')
            },
            itemSelected: function (item) {

                if (item.table) {
                    if (this.query.schema !== item.schema || this.query.table !== item.table) {
                        if (this.query.schema && this.query.table) {
                            this.updateSelecteds();
                        }
                        this.query.schema = item.schema;
                        this.query.table = item.table;
                        this.query.columns = [];
                    }

                    if (item.column) {
                        const selected = !!item.selected;
                        this.$set(item, 'selected', !selected);
                        let index = this.query.columns.indexOf(item.column);
                        if (index === -1) {
                            this.query.columns.push(item.column);
                        } else {
                            this.query.columns.splice(index, 1);
                        }
                    }

                    const columns = this.query.columns.length > 0 ? this.query.columns.join(', ') : '*';

                    let query = `SELECT ${columns} FROM ${item.schema}.${item.table}`;

                    if (['comercio', 'charm9', 'clini9'].includes(this.selectedDB)) {
                        query += ' WHERE id_empresa = ';
                    }

                    this.updateQuery(query);
                }

                this.updateHeight();

            },
            /**
             * Remove a seleção da tabela anterior
             */
            updateSelecteds() {
                const indexServer = this.databases.findIndex(server => server.name === this.selectedServer);
                if (indexServer === -1) return;
                const indexDB = this.databases[indexServer].dbs.findIndex(db => db.banco === this.selectedDB);
                const indexSchema = this.databases[indexServer].dbs[indexDB].children.findIndex(schema => schema.title === this.query.schema);
                const indexTable = this.databases[indexServer].dbs[indexDB].children[indexSchema].children.findIndex(table => table.title === this.query.table);
                this.databases[indexServer].dbs[indexDB].children[indexSchema].children[indexTable].children.forEach(old => {
                    this.$set(old, 'selected', false);
                });
            },
            async selectDb(servidor, banco, db) {
                if (servidor !== this.selectedServer) {
                    await this.changeServer(servidor);
                }
                await this.updateSelectedDB(banco);
                if (db.children && db.children.length > 0) return;
                this.initLoading();
                try {
                    const {data} = await this.$axios.get(`queries/tabelas/${servidor}/${banco}`);

                    const children = this.mountTree(data);

                    this.$set(db, 'children', children);

                    this.updateHeight();

                } catch({message}) {
                    this.$vs.notify({title: 'Erro', text: message, color: "rgb(242, 19, 93)", position: 'top-right'});
                }
                this.stopLoading();
            },
            mountTree(data) {
                const tree = data.reduce((carry, item) => {
                    const {table_schema, table_name, column_name, data_type, description } = item;
                    let indexSchema = carry.findIndex(schema => schema.title === table_schema);
                    if (indexSchema === -1) {
                        indexSchema = carry.length;
                        carry.push({
                            title: table_schema,
                            icon: 'FolderIcon',
                            children: []
                        });
                    }
                    let indexTable = carry[indexSchema].children.findIndex(table => table.title === table_name);
                    if (indexTable === -1) {
                        indexTable = carry[indexSchema].children.length;
                        carry[indexSchema].children.push({
                            title: table_name,
                            schema: table_schema,
                            table: table_name,
                            icon: 'GridIcon',
                            children: []
                        });
                    }

                    let indexColumn = carry[indexSchema].children[indexTable].children.findIndex(table => table.title === column_name);
                    if (indexColumn === -1) {
                        carry[indexSchema].children[indexTable].children.push({
                            title: `${column_name} <span style="font-size: 70%;" class="text-grey">${data_type}</span>`,
                            schema: table_schema,
                            table: table_name,
                            column: column_name,
                            tooltip: {
                                title: data_type,
                                text: description
                            },
                            icon: 'ServerIcon',
                        });
                    }
                    return carry;
                }, []);

                return tree;
            }
        }
    }
</script>

<style>
    .db-list {
        -webkit-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
    }
    .rotate90 {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    .db-title {
        align-items: center;
        display: flex;
        line-height: 28px;
        font-size: 14px;
        cursor: pointer;
        padding-left: 2px;
     }
    .db-title .feather-icon {
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        margin-right: 5px;
    }
    #queriesSidebar .con-content--item {
        padding-top: 0;
    }
</style>
